// @wc-ignore-file
import type { Notification } from "./notifications.types";

type ShareType = Extract<Notification["type"], "document_shared" | "chat_shared">;

export type ShareTarget =
  | {
      to: "/workspaces/$slug/projects/$projectSlug/docs/$docId";
      params: { slug: string; projectSlug: string; docId: string };
      search: Record<string, never>;
    }
  | {
      to: "/workspaces/$slug/projects/$projectSlug/chats/$chatId";
      params: { slug: string; projectSlug: string; chatId: string };
      search: { messageId: undefined; draft: undefined };
    };

export function isShareNotification(
  notification: Pick<Notification, "type">,
): notification is Pick<Notification, "type"> & { type: ShareType } {
  return notification.type === "document_shared" || notification.type === "chat_shared";
}

/**
 * CR-263: where a share notification leads — the shared item itself, with no
 * mention / comment / message target (nothing inside it is addressed to the
 * recipient). chat_shared covers AI chats and message rooms: both open on the
 * chats/$chatId route, which picks the right view from the room's type.
 * KEEP IN SYNC with resolveNotificationUrl in
 * backend/api-server/src/routes/notification-email-worker.ts.
 */
export function shareTarget(
  type: ShareType,
  containerId: string,
  slugs: { workspaceSlug: string; projectSlug: string },
): ShareTarget {
  if (type === "document_shared") {
    return {
      to: "/workspaces/$slug/projects/$projectSlug/docs/$docId",
      params: { slug: slugs.workspaceSlug, projectSlug: slugs.projectSlug, docId: containerId },
      search: {},
    };
  }
  return {
    to: "/workspaces/$slug/projects/$projectSlug/chats/$chatId",
    params: { slug: slugs.workspaceSlug, projectSlug: slugs.projectSlug, chatId: containerId },
    search: { messageId: undefined, draft: undefined },
  };
}
